/*
 * @Author: cq
 * @LastEditors: cq
 * @Date: 2025-03-24 16:32:36
 * @LastEditTime: 2025-04-02 16:14:03
 * @FilePath: \point-cloud-analysis\src\materials\ClassificationScheme.js
 */

import * as THREE from "../../libs/three.js/build/three.module.js";

export const ClassificationScheme = {

	DEFAULT: {
		0: { visible: true, name: '钢轨 Rails', color: [154 / 255, 107 / 255, 56 / 255, 1.0] },
		1: { visible: true, name: '道床 Track bed', color: [160 / 255, 112 / 255, 160 / 255, 1.0] },
		2: { visible: true, name: '桅杆 Masts', color: [251 / 255, 143 / 255, 49 / 255, 1.0] },
		3: { visible: true, name: '支撑装置 Support devices', color: [62 / 255, 170 / 255, 163 / 255, 1.0] },
		4: { visible: true, name: '架空线 Overhead lines', color: [229 / 255, 202 / 255, 63 / 255, 1.0] },
		5: { visible: true, name: '围栏 Fences', color: [101 / 255, 101 / 255, 206 / 255, 1.0] },
		6: { visible: true, name: '电线杆 Poles', color: [180 / 255, 47 / 255, 174 / 255, 1.0] },
		7: { visible: true, name: '植被 Vegetation', color: [166 / 255, 255 / 255, 64 / 255, 1.0] },
		8: { visible: true, name: '建筑物 Buildings', color: [253 / 255, 51 / 255, 103 / 255, 1.0] },
		9: { visible: true, name: '地面 Ground', color: [154 / 255, 194 / 255, 231 / 255, 1.0] },
		DEFAULT: { visible: true, name: 'default', color: [218 / 255, 219 / 255, 220 / 255, 1.0] },
	}
};

Object.defineProperty(ClassificationScheme, 'RANDOM', {
	get: function () {

		let scheme = {};

		for (let i = 0; i <= 255; i++) {
			scheme[i] = new THREE.Vector4(Math.random(), Math.random(), Math.random());
		}

		scheme["DEFAULT"] = new THREE.Vector4(Math.random(), Math.random(), Math.random());

		return scheme;
	}
});